import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Form, Button, Message, Header } from 'semantic-ui-react';
import { reduxForm } from 'redux-form/immutable';

import { login, load, updateUserWithShopifyToken } from '../../redux/modules/auth';
import {
  acceptOrganizationInvite,
} from '../../redux/modules/organization';
import Input from '../Form/Input';
import { required, email } from '../../utils/validations';
import config from '../../config';
import { queryStringToObject } from '../../helpers/commonHelper';
import './style.css';

class Login extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    handleSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
    loginBusy: PropTypes.bool,
    loginError: PropTypes.string,
    location: PropTypes.object,
    shopifyToken: PropTypes.string,
    shopifyStore: PropTypes.string
  };

  static defaultProps = {
    dispatch: null,
    handleSubmit: null,
    isLoading: false,
    loginBusy: false,
    loginError: '',
    location: {}
  };

  componentWillMount() {
    const { dispatch, shopifyToken, shopifyStore, location } = this.props;
    const { search } = location;

    const res = queryStringToObject(search);

    if(res && res.invite_token) {
      const inviteToken = res.invite_token;

      dispatch(acceptOrganizationInvite(inviteToken));
    }

    dispatch(load(false, shopifyToken))
    .then(async res => {
      if(res && res.id && !res.isShopifyUser && shopifyToken) {
        await dispatch(updateUserWithShopifyToken({ shopifyToken, shopifyStore }));
      }
    });
  }

  // login handler
  _login = (formData) => {
    const { dispatch } = this.props;
    const user = formData.toJS();
    dispatch(login(user.username, user.pwd));
  };

  getPromotionalCampaignStorage() {
    const promotionalCampaignStorage = localStorage.getItem('promotionalCampaign');
    return promotionalCampaignStorage
      ? JSON.parse(promotionalCampaignStorage)
      : { pluginId: null, viewCount: 0, version: null };
  }

  updatePromotionalCampaignStorage(currentData) {
    const newPromotionalCampaignStorage = {
      viewCount: currentData.viewCount + 1,
      pluginId: config.promotionalCampaign.pluginId,
      version: config.promotionalCampaign.version
    };

    localStorage.setItem(
      'promotionalCampaign',
      JSON.stringify(newPromotionalCampaignStorage)
    );
  }

  injectPiP(promotionalCampaignStorage) {
    const pipAlreadyInjected = document.getElementById('videoPeelPopup');
    if (pipAlreadyInjected) return;

    const pipScript = document.createElement('script');
    pipScript.src = `${config.pluginURL}/pip.js`;
    pipScript.type = 'text/javascript';
    pipScript.id = 'videoPeelPopup';
    pipScript.dataset.plugin = config.promotionalCampaign.pluginId;
    pipScript.dataset.type = 'pip';
    document.body.appendChild(pipScript);
    this.updatePromotionalCampaignStorage(promotionalCampaignStorage);
  }

  handlePromotionalCampaign() {
    const { promotionalCampaign } = config;
    if (!promotionalCampaign || !promotionalCampaign.enabled) {
      return;
    }

    const currentDate = new Date();
    if (
      promotionalCampaign.expiresIn &&
      currentDate > new Date(promotionalCampaign.expiresIn)
    ) {
      return;
    }

    const promotionalCampaignStorage = this.getPromotionalCampaignStorage();

    const viewCount =
      promotionalCampaignStorage.pluginId !== promotionalCampaign.pluginId ||
      promotionalCampaignStorage.version !== promotionalCampaign.version
        ? 0
        : promotionalCampaignStorage.viewCount;

    if (viewCount === 0) {
      return this.injectPiP({
        ...promotionalCampaignStorage,
        viewCount,
      });
    }

    const showPromotionalCampaign =
      promotionalCampaignStorage.pluginId === promotionalCampaign.pluginId &&
      promotionalCampaignStorage.viewCount < promotionalCampaign.maxViewCount &&
      promotionalCampaign.version >= promotionalCampaignStorage.version;

    if (showPromotionalCampaign) {
      this.injectPiP(promotionalCampaignStorage);
    }
  }

  render() {
    const {
      handleSubmit,
      isLoading,
      loginBusy,
      loginError,
      me,
      shopifyToken,
      shopifyStore
    } = this.props;

    if (me && me.id) {
      // Let's be extra-specially sure this method exists
      // it will crash the entire app if someone is using
      // an Ad Blocker that blocks Heap from being loaded
      window.heap && window.heap.identify && window.heap.identify(me.email);
      this.handlePromotionalCampaign();
      const { from } = this.props.location.state || { from: { pathname: me.role === 2 ? '/campaign' : '/clients' } };
      return <Redirect to= {from} />;
    }
    const signupUrl = shopifyToken
      ? `/signup/free/?shopifyToken=${shopifyToken}&store=${shopifyStore}`
      : 'https://videopeel.com/pricing';

    return (
      <div className="logincard" onSubmit={handleSubmit(this._login)} >
        <Form className="login-form">
          <Header as='h3' className="side">LOGIN</Header>
          <Input
            className="username"
            name="username"
            icon="user"
            iconPosition="left"
            placeholder="Username"
            type="text"
            size="large"
            validate={[required, email]}
            autoCorrect="off"
            autoCapitalize="none"
          />
          <Input
            name="pwd"
            icon="key"
            iconPosition="left"
            placeholder="Password"
            type="password"
            size="large"
            validate={[required]}
          />
          <Button className="ui large fluid button front" type="submit"  primary loading={isLoading || loginBusy} >
            Login
            <i aria-hidden="true" className="chevron right icon"></i>
          </Button>
          <p className="signcentered"> <a href={signupUrl}>No account? <span>Sign Up</span></a></p>
          <p className="signcentered"> <a href="./forgot/password">Forgot Password? <span>Click Here</span></a></p>
          <p className="homecentered"><a href=""><i aria-hidden="true" className="home icon"></i>Back to Home</a></p>
        </Form>

        {
          loginError && (
            <Message error content={loginError} />
          )
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    me: state.get('auth').get('user'),
    isLoading: state.get('auth').get('isLoad'),
    loginBusy: state.get('auth').get('isLogin'),
    loginError: state.get('auth').get('loginErr'),
  };
}

export { Login as DisconnectedLogin };

const form = reduxForm({ form: 'login' })(Login);
export default connect(mapStateToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js